(function () {
  'use strict';

  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var inEditor = window.Shopify && window.Shopify.designMode;
  var revealObserver = null;

  function revealNow(els) {
    els.forEach(function (el) { el.classList.add('is-in'); });
  }

  function initReveals(scope) {
    var root = scope || document;
    var els = root.querySelectorAll('.reveal:not(.is-in)');
    if (!els.length) return;
    if (reduceMotion || inEditor || !('IntersectionObserver' in window)) {
      revealNow(els);
      return;
    }
    if (!revealObserver) {
      revealObserver = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-in');
            revealObserver.unobserve(entry.target);
          }
        });
      }, { rootMargin: '0px 0px -8% 0px', threshold: 0.1 });
    }
    els.forEach(function (el) { revealObserver.observe(el); });
  }

  function initHeader() {
    var header = document.querySelector('[data-header]');
    if (!header) return;
    var onScroll = function () {
      header.classList.toggle('is-scrolled', window.scrollY > 24);
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();

    var toggle = document.querySelector('[data-drawer-toggle]');
    var drawer = document.querySelector('[data-drawer]');
    if (toggle && drawer) {
      toggle.addEventListener('click', function () {
        var open = drawer.classList.toggle('is-open');
        toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
        document.documentElement.style.overflow = open ? 'hidden' : '';
      });
      drawer.addEventListener('click', function (e) {
        if (e.target.closest('[data-drawer-close]') || e.target === drawer) {
          drawer.classList.remove('is-open');
          toggle.setAttribute('aria-expanded', 'false');
          document.documentElement.style.overflow = '';
        }
      });
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && drawer.classList.contains('is-open')) {
          drawer.classList.remove('is-open');
          toggle.setAttribute('aria-expanded', 'false');
          document.documentElement.style.overflow = '';
          toggle.focus();
        }
      });
    }
  }

  function initAnnouncement() {
    var bar = document.querySelector('[data-announcement]');
    if (!bar) return;
    var key = 'rr-announcement-dismissed';
    try {
      if (sessionStorage.getItem(key) === bar.getAttribute('data-announcement')) {
        bar.hidden = true;
        return;
      }
    } catch (err) { /* storage unavailable */ }
    var close = bar.querySelector('[data-announcement-close]');
    if (close) {
      close.addEventListener('click', function () {
        bar.hidden = true;
        try { sessionStorage.setItem(key, bar.getAttribute('data-announcement')); } catch (err) { /* noop */ }
      });
    }
  }

  function initVariantRadios() {
    document.querySelectorAll('[data-variant-radios]').forEach(function (group) {
      var priceEls = document.querySelectorAll('[data-price-display]');
      var idInputs = document.querySelectorAll('[data-variant-id-input]');
      group.addEventListener('change', function (e) {
        var input = e.target.closest('input[type="radio"]');
        if (!input) return;
        idInputs.forEach(function (idInput) { idInput.value = input.value; });
        if (input.dataset.price) {
          priceEls.forEach(function (el) { el.textContent = input.dataset.price; });
        }
        var available = input.dataset.available !== 'false';
        document.querySelectorAll('[data-atc-button]').forEach(function (btn) {
          btn.disabled = !available;
          var label = btn.querySelector('[data-atc-label]');
          if (label) label.textContent = available ? btn.dataset.labelAdd : btn.dataset.labelSoldOut;
        });
      });
    });
  }

  function initStickyAtc() {
    var bar = document.querySelector('[data-sticky-atc]');
    var anchor = document.querySelector('[data-buybox-anchor]');
    if (!bar || !anchor || !('IntersectionObserver' in window)) return;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        var show = !entry.isIntersecting && entry.boundingClientRect.top < 0;
        bar.classList.toggle('is-visible', show);
        bar.setAttribute('aria-hidden', show ? 'false' : 'true');
      });
    }, { threshold: 0 });
    io.observe(anchor);
  }

  function initVideoFacades() {
    document.addEventListener('click', function (e) {
      var facade = e.target.closest('[data-yt-facade]');
      if (!facade) return;
      var id = facade.getAttribute('data-yt-facade');
      if (!id) return;
      var iframe = document.createElement('iframe');
      iframe.src = 'https://www.youtube-nocookie.com/embed/' + encodeURIComponent(id) + '?autoplay=1&rel=0';
      iframe.title = facade.getAttribute('data-yt-title') || 'Video';
      iframe.allow = 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture';
      iframe.allowFullscreen = true;
      iframe.style.cssText = 'position:absolute;inset:0;width:100%;height:100%;border:0;';
      facade.innerHTML = '';
      facade.appendChild(iframe);
      facade.removeAttribute('data-yt-facade');
    });
  }

  function initQuantity() {
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-qty-change]');
      if (!btn) return;
      var input = btn.parentElement.querySelector('input[type="number"]');
      if (!input) return;
      var step = btn.getAttribute('data-qty-change') === 'up' ? 1 : -1;
      var next = Math.max(parseInt(input.min || '0', 10), (parseInt(input.value, 10) || 0) + step);
      input.value = next;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  function init() {
    initReveals();
    initHeader();
    initAnnouncement();
    initVariantRadios();
    initStickyAtc();
    initVideoFacades();
    initQuantity();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function (e) {
    initReveals(e.target);
    if (e.target.querySelector && e.target.querySelector('[data-sticky-atc], [data-buybox-anchor]')) {
      initStickyAtc();
    }
  });

  document.addEventListener('shopify:section:select', function (e) {
    initReveals(e.target);
  });
})();
